import Stripe from 'stripe'

export const stripeCli = new Stripe(import.meta.env.VITE_STRIPE_CUSTOM_KEY, { apiVersion: '2026-09-30.endive', typescript: true })
